import Instance from '../../../../Axios';

// New Actions for the app

const GetTooltipsLimpeza = () => async (dispatch) => {
  await Instance()
    .get(`/backend/checklist/tooltip`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_TOOLTIPS_LIMPEZA', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTooltipsLimpeza;
